/**
 * This function moves an item in an array from one index to another.
 * @param array
 * @param _fromIndex
 * @param _toIndex
 * @returns
 */
export function moveArray<T>(array: T[], _fromIndex: number, _toIndex: number): T[] {
	const fromIndex = _fromIndex;
	let toIndex = _toIndex;

	const newArray = [...array];
	if (fromIndex < 0 || fromIndex >= array.length) return newArray;
	if (toIndex < 0) toIndex = 0;
	if (toIndex >= array.length) toIndex = array.length - 1;
	const [movedItem] = newArray.splice(fromIndex, 1);
	if (!movedItem) return newArray;
	newArray.splice(toIndex, 0, movedItem);
	return newArray;
}
